export default {
    locale: 'hy',
    country: 'AM',
    loginForm: {
        byAccountBtn: 'Հաշվի գաղտնաբառի մուտք',
        byPhoneBtn: 'Բջջային հեռախոսահամարի մուտք',
        accountPlaceholder: 'Խնդրում ենք մուտքագրել հաշիվը (կանխադրված հաշիվ ADMIN)',
        passwordPlaceholder: 'Խնդրում ենք մուտքագրել գաղտնաբառը (լռելյայն գաղտնաբառ 123456)',
        autoLogin: 'ավտոմատ մուտք',
        forgetBtn: 'Մոռացել եք գաղտնաբառը',
        loginBtn: 'մուտք գործել',
        byAccountTip: {
            emptyErr: 'Հաշիվը չի կարող դատարկ լինել'
        },
        byPasswordTip: {
            emptyErr: 'գաղտնաբառը չի կարող դատարկ լինել'
        },
        byValidTip: {
            emptyErr: 'ստուգման կոդը պետք է լրացվի'
        },
        sendMsg: {
            repeatErr: 'Մի ուղարկեք մի քանի անգամ',
            success: 'Հաջող',
            codeTip: 'Ձեր հաստատման կոդը ՝'
        },
        phonePlaceholder: 'Խնդրում ենք մուտքագրել հեռախոսահամարը',
        validPlaceholder: 'Հաստատման ծածկագիր',
        validBtn: 'ստացեք հաստատման ծածկագիր',
        loginSuccess: 'մուտքը հաջող է'
    },
    menuObj: {
        basicFeature: 'Հիմնական ունակություն',
        cpUse: 'Բաղադրիչի օգտագործումը',
        childMenu: {
            0: 'Հիմնական շրջանակ',
            1: 'Հիմնական ունակություն',
            '0-0': 'Vue',
            '0-1': 'Մրջյունների ձևավորում',
            '0-2': 'Admin Vue- ի մոտ',
            '1-0': 'Շրջանակային գործառույթ',
            '1-0-0': 'Նախագծի կազմաձևում',
            '1-0-1': 'Առջևի մատյան',
            '1-0-2': 'Տեղական ծաղր',
            '1-0-3': 'համաշխարհայնացում',
            '1-0-4': 'Տվյալների բառարան',
            '1-0-5': 'EventBus',
            '1-0-6': 'Գործիքակազմ',
            '1-0-7': 'Մուտքի հսկողություն',
            '1-0-8': 'թեժ ստեղն',
            '1-1': 'Էջի գործառույթ',
            '1-1-0': 'Բաղադրիչի էջ',
            '1-1-1': 'url էջ',
            '1-1-2': 'Թույլտվության էջ չկա',
            '1-1-3': '404 էջ'
        },
        errorTip: {
            notfoundTip: 'Այս ուղու տակ գտնվող բաղադրիչը չի գտնվել',
            emptyErr: 'Չկազմակերպված բաղադրիչի ուղին'
        }
    },
    coreMenuObj: {
        defaultMenu: {
            home: 'տուն'
        }
    },
    sysInfo: {
        sysIntro: 'Vue- ի և Ant- ի դիզայնի վրա հիմնված միջին և հետին ծայրի առջևի վերջի զարգացման օգտակար շրջանակ'
    },
    requestInfo: {
        withoutUrl: 'Հարցման հասցեն չի կարող դատարկ լինել',
        networkErr: 'Networkանցի հարցումը ձախողվեց, փորձեք ավելի ուշ'
    },
    localeMap: {
        ar: 'Արաբերեն',
        bg: 'Բուլղարերեն',
        ca: 'Կատալաներեն',
        cs: 'Չեխերեն',
        da: 'Դանիերեն',
        de: 'Գերմանական',
        el: 'Հունական',
        'en-gb': 'Անգլերեն',
        en: 'Անգլերեն',
        es: 'Իսպաներեն',
        et: 'Էստոնական',
        fa: 'Պարսկերեն',
        fi: 'Ֆիններեն',
        fr: 'Ֆրանսերեն',
        he: 'Եբրայերեն',
        hi: 'Հինդի',
        hr: 'Խորվաթերեն',
        hu: 'Հունգարացի',
        hy: 'հայերեն',
        id: 'Ինդոնեզերեն',
        is: 'Իսլանդերեն',
        it: 'Իտալերեն',
        ja: 'Ճապոներեն',
        kn: 'Կաննադա',
        ko: 'Կորեերեն',
        'ku-iq': 'Կենտրոնական քրդերեն',
        lv: 'Կենտրոնական քրդերեն',
        mk: 'Մակեդոներեն',
        'mn-mn': 'Մոնղոլական',
        'ms-my': 'Մալայերեն',
        nb: 'Նորվեգերեն',
        'ne-np': 'Նեպալերեն',
        'nl-be': 'Ֆլամանդերեն',
        nl: 'Հոլանդերեն',
        pl: 'Լեհերեն',
        'pt-br': 'Բրազիլական պորտուգալերեն',
        pt: 'Եվրոպական պորտուգալերեն',
        ro: 'Ռումիներեն',
        ru: 'Ռուսաց լեզու',
        sk: 'Սլովակերեն',
        sl: 'Սլովեներեն',
        sr: 'Սերբերեն',
        sv: 'Շվեդերեն',
        ta: 'Թամիլերեն',
        th: 'Թայերեն',
        tr: 'Թուրքերեն',
        uk: 'Ուկրաինացի',
        vi: 'Վիետնամերեն',
        'zh-cn': 'Պարզեցված չինարեն',
        'zh-tw': 'ավանդական չինարեն'
    },
    tagObj: {
        closeAll: 'Փակեք բոլոր ներդիրները',
        closeCur: 'Փակել ընթացիկ ներդիրը',
        closeOther: 'Փակել այլ ներդիրները',
        closeRight: 'Փակ աջ պիտակը',
        singlePage: 'Անկախ էջ',
        refreshPage: 'թարմացնել էջը',
        affixPage: 'Կցել էջը',
        cancelAffixPage: 'Ապամոնտաժել',
        errorTip: {
            homePageCloseError: 'Գլխավոր էջը չի թույլատրվում փակել',
            affixPageCloseError: 'Հաստատված էջը չի թույլատրվում փակել',
            homePageAffixError: 'Գլխավոր էջը հնարավոր չէ կապել'
        },
        checkSave: 'Youանկանու՞մ եք փակել էջը: (Խնդրում ենք համոզվել, որ կարմիրով նշված էջի բովանդակությունը պահված է)',
        cancelClose: 'Փակ գործողությունը չեղյալ է հայտարարվել'
    },
    personalCenter: {
        frontendLog: 'Առջևի մատյան',
        customSetting: 'Անհատականացում',
        customClean: 'Մաքրել կազմաձևը',
        cacheClean: 'Դատարկեք քեշը',
        logout: 'դուրս գալ',
        errorTip: {
            cleanSuccess: 'Դատարկվում է հաջողությամբ'
        }
    },
    errorPage: {
        errorTip: {
            notfoundTip: 'Ներեցեք, ձեր այցելած էջը գոյություն չունի',
            notrightTip: 'Ներեցեք, այս էջին մուտք գործելու թույլտվություն չունեք',
            noserviceTip: 'Ներեցեք, սերվերի հետ կապված խնդիր առաջացավ, փորձեք ավելի ուշ'
        },
        btnText: 'Փակել էջը'
    },
    searchPanel: {
        btn: {
            search: 'Հարցրեք',
            shrink: 'Մի կողմ դրեք',
            reset: 'Վերականգնել',
            unshrink: 'Բացել'
        }
    },
    logline: {
        list: 'Մատյանների ցուցակ',
        detail: 'Մուտքի մանրամասները',
        btnList: {
            export: 'Արտահանում',
            remove: 'Դատարկ'
        },
        time: {
            plh: 'Խնդրում ենք ընտրել ժամային միջակայք',
            range: 'ժամկետը',
            halfDay: 'Կես օր',
            oneDay: 'մեկ օրում',
            weekDay: 'մեկ շաբաթվա ընթացքում',
            monthDay: 'Մեկ ամսվա ընթացքում'
        },
        type: {
            logType: 'Մուտքի տեսակը',
            plh: 'Խնդրում ենք ընտրել գրանցամատյանի տեսակը'
        },
        tableColumns: {
            index: 'Սերիական համար',
            desc: 'Մուտքի նկարագրություն',
            type: 'Մուտքի տեսակը',
            time: 'ժամանակը',
            op: 'գործող'
        },
        request: 'Հայցել տվյալներ',
        error: {
            cancel: 'Դատարկ գործողությունը չեղյալ է հայտարարվել',
            confirm: 'Անկանու՞մ եք մաքրել գրանցամատյանը: (Եթե տեղեկամատյանը դատարկվում է, այն հնարավոր չէ հետ վերցնել)'
        },
        success: 'Դատարկը դատարկվել է'
    },
    comTable: {
        delete: {
            title: 'Մաքրել կազմաձևը'
        },
        columns: {
            title: 'Սյունակի կարգավորումներ',
            all: 'ընտրել բոլորը',
            reset: 'Վերականգնել',
            fixedLeft: 'Ֆիքսվեց ձախ',
            fixedRight: 'Ուղղակի ամրագրված է',
            cancelFixed: 'Ապամոնտաժել'
        },
        size: {
            title: 'Տողի բարձրությունը',
            small: 'նեղ',
            normal: 'մեջ',
            large: 'լայնությունը'
        },
        fullscreen: 'լրիվ էկրանով',
        unFullscreen: 'Չեղարկել ամբողջ էկրանը'
    },
    normalBtn: {
        detail: 'Դիտել'
    },
    setting: {
        customEntry: 'Արագ մուտք',
        systemSwitch: 'Համակարգի կազմաձևում',
        isMock: 'Անկախ ծաղրից',
        isHotKey: 'Անկախ նրանից, թե դյուրանցման ստեղն է',
        isBreadCrumb: 'Անկախ նրանից, թե հացի փշրանքներ',
        isCache: 'Անկախ նրանից, թե քեշ է',
        isI18n: 'Արդյո՞ք պետք է միջազգայնացնել'
    },
    pagingInfo: {
        total: 'Ընդհանուր առմամբ',
        uint: 'Հոդված',
        items: 'ձայնագրությունը'
    }
}
